import React from 'react';
import { useImageUrl } from '../../services/uploads';

interface ChatAvatarProps {
  src?: string | null;
  name?: string | null;
  size?: number;
  online?: boolean;
  className?: string;
}

function initialsOf(name: string | null | undefined): string {
  if (!name) return '·';
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

const ChatAvatar: React.FC<ChatAvatarProps> = ({ src, name, size = 40, online, className }) => {
  const [resolved] = useImageUrl(src ?? null);
  const dim = `${size}px`;
  const dotSize = Math.max(8, Math.round(size * 0.22));
  return (
    <div className={`relative shrink-0 ${className ?? ''}`} style={{ width: dim, height: dim }}>
      {resolved ? (
        <img
          src={resolved}
          alt={name ?? ''}
          className="w-full h-full rounded-full object-cover"
        />
      ) : (
        <div
          className="w-full h-full rounded-full bg-primary-100 dark:bg-primary-900/40 flex items-center justify-center text-primary-700 dark:text-primary-200 font-semibold"
          style={{ fontSize: Math.round(size * 0.36) }}
        >
          {initialsOf(name)}
        </div>
      )}
      {online && (
        <span
          aria-label="Online"
          className="absolute bottom-0 right-0 rounded-full border-2 border-background-primary bg-success-500"
          style={{ width: dotSize, height: dotSize }}
        />
      )}
    </div>
  );
};

export default ChatAvatar;
